<template>
  <div class="home">
    <v-row>
      <v-col>
        <div class="display-3 font-weight-thin mb-4">
          Contact
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          If you happen to have any questions about the Ulmer Nest, please contact us through one of the following e-Mail adresses. We'll get back to you as fast as possible:
        </p>
        <p>
          <a href="mailto:info@ulmernest.de">
            <div class="font-weight-bold mb-3 mt-3">
              <v-icon small class="mr-3 mb-1">
                fa fa-envelope
              </v-icon>
              info@ulmernest.de
            </div>
          </a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="display-3 font-weight-thin mb-4">
          Presse
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          You can also find all information provided on this website as a PDF, together with the respective photos in the following download:
        </p>
        <p>
          <a href="https://ulmernest.de/downloads/presse_191107_V1.zip" target="_blank">
            <div class="font-weight-bold">
              <v-icon small class="mr-3 mb-1">
                fa fa-cloud-download-alt
              </v-icon>
              Press Kit 2020 (PDF + Photos)
            </div>
          </a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          Images freely available with indication of the copyright holder (as mentioned in the corresponding .rtf-files of each folder):
        </p>
        <p>
          <a href="https://ulmernest.de/downloads/ulmernest_media_210303_V1.zip" target="_blank">
            <div class="font-weight-bold">
              <v-icon small class="mr-3 mb-1">
                fa fa-cloud-download-alt
              </v-icon>
              Images 2020 + 2021
            </div>
          </a>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          For any further questions, or to provide us with sepcimen copies please use the following contact:
        </p>
        <p>
          <a href="mailto:presse@ulmernest.de">
            <div class="font-weight-bold">
              <v-icon small class="mr-3 mb-1">
                fa fa-envelope
              </v-icon>
              presse@ulmernest.de
            </div>
          </a>
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  }
}
</script>
